// 查询活动信息列表
import request from "@/utils/request";

export function listTrain(query) {
    return request({
        url: '/h5/train/list',
        method: 'get',
        params: query
    })
}

// 查询课程信息详情
export function getLrainById(id) {
    return request({
        url: '/h5/train/'+id,
        method: 'get',
    })
}

// 增加点击数
export function upTrainById(id) {
    return request({
        url: '/h5/train/clink/'+id,
        method: 'get',
    })
}
